import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'arrayJoin' })
export class ArrayJoinPipe implements PipeTransform {
  transform(array: any[], opts: { separator: string; valueAccessor?: string } = { separator: ' | ' }): string {
    const { separator, valueAccessor } = opts;
    return !!array ? array.map(item => (valueAccessor ? item[valueAccessor] : item)).join(separator) : '';
  }
}
